import { render, staticRenderFns } from "./SectionPicker.vue?vue&type=template&id=6caff160&scoped=true&"
import script from "./SectionPicker.vue?vue&type=script&lang=js&"
export * from "./SectionPicker.vue?vue&type=script&lang=js&"
import style0 from "./SectionPicker.vue?vue&type=style&index=0&id=6caff160&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6caff160",
  null
  
)

export default component.exports